module.exports = __webpack_public_path__ + "static/media/difficulty-breathing.c745352e.svg";